<template>
	<div class="col-md-12 col-sm-12 col-xs-12">
		<div class="trans-fillin">
			<div class="row">
				<div class="form-header">
					<p>为了顺利开通微信服务, 请如实填写如下查账信息</p>
				</div>	
			</div>
			<div class="row" @click="onFocus" v-if="showBank">
				<div>
					<mt-field label="转出银行名称" placeholder="请输入您转出银行的名称，例如“建设银行”" v-model="trade.bank_name" type="text"></mt-field>
				</div>
			</div>
			<div class="row" @click="onFocus" v-if="showBank">
				<div>
					<mt-field label="付款人姓名" placeholder="请输入您转出银行的户名，例如“张三”" v-model="trade.bank_account_name" type="text"></mt-field>
				</div>
			</div>			
			<div class="row" @click="onFocus" v-if="showTradeNo">
				<div>
					<mt-field :label="lblTradeNo" :placeholder="plTradeNo" v-model="trade.trade_no" type="tel" :attr="attr"></mt-field>
				</div>
			</div>
			<div class="row" @click="onFocus" v-if="showAlipayId">
				<div>
					<mt-field label="付款人姓名" placeholder="请输入您的真实姓名" v-model="trade.alipay_id" type="text"></mt-field>
				</div>
			</div>
			<div class="row" @click="onFocus">
				<div>
					<mt-field label="支付金额" placeholder="请输入您的支付金额" v-model="trade.amount" type="tel" :attr="attr" disableClear></mt-field>
				</div>
			</div>
			<div class="row" @click="onPaidTimeClick">
				<div>
					<mt-field label="支付日期" placeholder="请输入您的支付日期" v-model="trade.paid_time" type="text" readonly></mt-field>
				</div>
			</div>
			<div class="row">
				<div class="actions mt-50">
					<mt-button type="primary" @click="onSubmitClick">保存</mt-button>
				</div>
			</div>
			<div class="row" v-if="showBank">
				<div>
					<div class="bank-info">
						<div style="padding-top: 0px;text-align:center;" @click="toShowBankInfo">
							显示银行账号
						</div>
						<div v-show="showBankInfo" style="border-top: 1px dashed #666; margin-top:10px;padding-top: 20px; line-height: 2.0">
						<p><button class="ac-copy" v-clipboard:copy="txAccount.company_name" v-clipboard:success="onCopied">{{ txAccount.company_name }}</button></p>
						<p><button class="ac-copy" v-clipboard:copy="txAccount.bank_address" v-clipboard:success="onCopied">{{ txAccount.bank_address }}</button></p>
						<p><button class="ac-copy" v-clipboard:copy="txAccount.bank_account" v-clipboard:success="onCopied">{{ accountPretty }}</button></p>
						<p>温馨提示：点击上面各行文本即可复制</p>
						</div>
					</div>
				</div>
			</div>
			<mt-datetime-picker ref="picker" type="datetime" v-model="pickerValue" @confirm="handleConfirm" :startDate="startDate" :endDate="endDate"></mt-datetime-picker>			
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import { Button, Field, DatetimePicker } from 'mint-ui'

export default {
	name: 'TransFillIn',
	data: () => ({
		'trade': {
			'trade_no': null,
			'amount': null,
			'paid_time': null,
			'route_code': 'P0000',
			'crm_pay_code': null,
			'payment_way': null,
			'bank_name': null,
			'bank_account_name': null,
			'alipay_id': null,
			'vendor_title': null,
			'hz_bank_account': null,
			'hz_bank_address': null
		},
		'pickerValue': new Date(),
		'endDate': new Date(),
		'startDate': new Date(),
		'showTradeNo': true,
		'showBank': false,
		'showBankInfo': false,
		'showAlipayId': false,
		'lblTradeNo': '交易单号',
		'plTradeNo': '请粘贴/输入交易单号',
		'attr': {'style': {'ime-mode': 'disabled'}}
	}),
	computed: {
		...mapGetters({
			txAccount: 'getTxAccount',
			orderInfo: 'getOrder',
			payment: 'getPayment'
		}),
		accountPretty () {
			if (this.txAccount) {
				let str = this.txAccount.bank_account || ''
				str = str.split(/(\d{4})/)
				return str.join(' ')
			}
			return ''
		}
	},
	components: {
		'mt-button': Button,
		'mt-field': Field,
		'mt-datetime-picker': DatetimePicker
	},
	created: function () {
	},
	mounted: function () {
		if (this.payment && !this.payment.payment_id) {
			Object.assign(this.trade, this.payment)
		}
		this.startDate = new Date()
		// console.log(this.startDate)
		this.startDate.setFullYear(this.startDate.getFullYear(), this.startDate.getMonth() - 1)
		// console.log(this.startDate)
		this.endDate = new Date()
		// console.log(this.endDate)
		this.setPageTitle('收款方: ' + this.txAccount.short_name)
		this.trade.vendor_title = this.txAccount.vendor_title
		this.trade.payment_way = this.txAccount.short_name
		this.trade.hz_bank_account = this.txAccount.bank_account
		this.trade.hz_bank_address = this.txAccount.bank_address
		this.trade.crm_pay_code = this.txAccount.short_code
		if (this.txAccount.weixin === true) {
			this.showTradeNo = this.txAccount.weixin
			this.showAlipayId = false
			this.lblTradeNo = '交易单号'
			this.plTradeNo = '请粘贴/输入微信交易单号'
		} else {
			this.showTradeNo = this.txAccount.alipay
			this.showAlipayId = this.txAccount.alipay
			this.lblTradeNo = '订单号'
			this.plTradeNo = '请粘贴/输入支付宝订单号'
		}
		this.showBank = !this.showTradeNo
	},
	methods: {
		onSubmitClick () {
			console.log(this.trade)
			if (this.showBank) {
				if (!this.trade.bank_name || this.trade.bank_name.length === 0) {
					this.toast('请输入您转出银行的名称')
					return
				}
				if (!this.trade.bank_account_name || this.trade.bank_account_name.length === 0) {
					this.toast('请输入您转出银行的户名')
					return
				}
			}
			if (!this.trade.amount || this.trade.amount.length === 0) {
				this.toast('请输入您的支付金额')
				return
			}
			if (parseFloat(this.trade.amount) <= 0 || isNaN(parseFloat(this.trade.amount))) {
				this.toast('转账金额必须大于0')
				return
			}
			if (!this.trade.paid_time || this.trade.paid_time.length === 0) {
				this.toast('请输入您的支付日期')
				return
			}
			if (this.showTradeNo) {
				if (!this.trade.trade_no || this.trade.trade_no.length === 0) {
					this.toast('请输入' + this.lblTradeNo)
					return
				}
			}
			if (this.showAlipayId) {
				if (!this.trade.alipay_id || this.trade.alipay_id.length === 0) {
					this.toast('请输入您的真实姓名')
					return
				}
			}
			if (this.trade.trade_no && !/^([0-9]+)$/.test(this.trade.trade_no)) {
				this.toast(this.lblTradeNo + '格式不正确, 请输入数字')
				return
			}
			let url = '/api/orders/payments/trans/' + this.orderInfo.order_no
			this.loading('正在保存...')
			this.$store.dispatch('clearPayment', {})
			this.$http.post(url, this.trade).then(response => {
				this.loadingHide()
				var rs = response.body
				if (rs.code === 0) {
					console.log('result: ', rs.data.order)
					this.$store.dispatch('setOrder', {'order': rs.data.order})
					this.$store.dispatch('setTransList', {'items': []})
					this.toast('保存成功')
					this.$router.go(-2)
				} else {
					if (rs.code === 10666) {
						this.toast(this.lblTradeNo + '已存在，不能重复使用，请确认您的输入')
					} else {
						this.handleHttpError(response)
					}
				}
			}, response => {
				console.log(response)
				this.handleHttpError(response)
			})
		},
		onFocus (e) {
			let ele = e.target
			if (!ele) {
				ele = e.srcElement
			}
			// console.log(ele)
			if (ele.tagName !== 'input') {
			}
			ele.focus()
		},
		onPaidTimeClick () {
			this.$refs.picker.open()
		},
		toShowBankInfo () {
			this.showBankInfo = !this.showBankInfo
		},
		onCopied () {
			this.toast('复制成功')
		},
		handleConfirm () {
			console.log(this.pickerValue)
			this.trade.paid_time = this.formatDate(this.pickerValue, 'yyyy-MM-dd HH:mm:ss')
		}
	}
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/payment/TransFillIn.vue